<template>
  <div class="container screener-content">
    <v-row>
      <v-col>
        <v-btn rounded text color="accent" @click="back"
          ><v-icon class="mr-2">bhi-arrow-left</v-icon>Back</v-btn
        >
        <h3 class="d-flex mt-4">
          {{ screener.title }}
          <v-spacer></v-spacer>
          <div>{{ screener.score }}&nbsp;<small>Total Score</small></div>
        </h3>
        <v-chip-group
          v-if="screenerProgress && screenerProgress.surveys"
          mandatory
          v-model="selected"
          active-class="white--text accent"
        >
          <v-chip
            v-for="screener in screenerProgress.surveys"
            :key="screener.id"
            :value="screener.id"
            @click="$emit('toScreener', screener.id)"
          >
            {{ screener.endDate | moment('MMMM Do, YYYY') }} -&nbsp;<strong>{{
              screener.score
            }}</strong>
          </v-chip>
        </v-chip-group>
        <v-expansion-panels>
          <v-expansion-panel
            v-for="(item, i) in screener.sections"
            :key="i"
            class="screener-section"
          >
            <v-expansion-panel-header>
              <h4>{{ item.title }}</h4>
              <v-spacer />
              <div class="screener-section__score">
                <strong>{{ item.summary || '&nbsp;' }}</strong>
                <horizontal-value-bar
                  small
                  type="score"
                  :value="item.score"
                  :total="item.maxScore"
                />
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <table>
                <tr>
                  <th>Question</th>
                  <th>Answer</th>
                  <th>Raw score</th>
                </tr>
                <tr v-for="(q, j) in item.questions" :key="'q-' + i + '-' + j">
                  <td>
                    <strong>{{ j + 1 }}. {{ q.title }}</strong>
                    {{ q.description }}
                  </td>
                  <td>
                    <div
                      v-for="(a, k) in q.answers"
                      :key="'a-' + i + '-' + j + '-' + k"
                    >
                      <div
                        v-if="
                          a.type == 'RADIO' && a.selected && !a.embeddedQuestion
                        "
                      >
                        {{ a.title }}
                      </div>
                      <div v-if="a.type == 'TEXT' && !a.embeddedQuestion">
                        <strong>{{ a.title }}</strong> {{ a.content || ' — ' }}
                      </div>
                      <div v-if="a.type == 'NUMBER' && !a.embeddedQuestion">
                        {{ a.value }}
                      </div>
                      <div
                        v-if="
                          a.type == 'CHECKBOX' &&
                            a.selected &&
                            !a.embeddedQuestion
                        "
                      >
                        {{ a.title }}
                      </div>
                      <div v-if="a.embeddedQuestion">
                        <span>{{ a.title }}</span
                        ><br />
                        <strong>{{ a.embeddedQuestion.title }}</strong
                        >:<br />
                        <div
                          v-for="(b, l) in a.embeddedQuestion.answers"
                          :key="'b-' + i + '-' + j + '-' + k + '-' + l"
                        >
                          <div
                            v-if="
                              b.type == 'RADIO' &&
                                b.selected &&
                                !b.embeddedQuestion
                            "
                          >
                            {{ b.title }}
                          </div>
                          <div v-if="b.type == 'TEXT' && !b.embeddedQuestion">
                            <strong>{{ b.title }}</strong>
                            {{ b.content || ' — ' }}
                          </div>
                          <div v-if="b.type == 'NUMBER' && !b.embeddedQuestion">
                            {{ b.value }}
                          </div>
                          <div
                            v-if="
                              b.type == 'CHECKBOX' &&
                                b.selected &&
                                !b.embeddedQuestion
                            "
                          >
                            {{ b.title }}
                          </div>
                          <div v-if="b.embeddedQuestion">
                            <span>{{ b.title }}</span
                            ><br />
                            <strong>{{ b.embeddedQuestion.title }}</strong
                            >:<br />
                            <div
                              v-for="(c, m) in b.embeddedQuestion.answers"
                              :key="
                                'c-' + i + '-' + j + '-' + k + '-' + l + '-' + m
                              "
                            >
                              <div v-if="c.type == 'RADIO' && c.selected">
                                {{ c.title }}
                              </div>
                              <div v-if="c.type == 'TEXT'">
                                <strong>{{ c.title }}</strong>
                                {{ c.content || ' — ' }}
                              </div>
                              <div v-if="c.type == 'NUMBER'">{{ c.value }}</div>
                              <div v-if="c.type == 'CHECKBOX' && c.selected">
                                {{ c.title }}
                              </div>
                            </div>
                            <br />
                          </div>
                        </div>
                        <br />
                      </div>
                    </div>
                  </td>
                  <td>
                    <v-icon size="14" class="mr-4">bhi-clock</v-icon
                    >{{ q.score }}
                  </td>
                </tr>
              </table>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import HorizontalValueBar from '@/components/exercises/HorizontalValueBar.vue'
export default {
  name: 'ScreenerContent',
  components: {
    HorizontalValueBar,
  },
  data() {
    return {
      selected: null,
    }
  },
  props: {
    screener: {
      type: Object,
      default: () => {},
    },
    screenerProgress: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    back() {
      this.$emit('back')
    },
  },
}
</script>

<style lang="scss">
.screener-content {
  flex: 1;
  padding: 0 10px 0;
  height: 100%;
  .v-chip-group {
    margin-bottom: 30px;
    .v-slide-group__content {
      background: $bh-gray--6;
      flex: 0;
      padding-left: 8px;
      border-radius: 20px;
    }
  }

  .screener-section {
    h4 {
      color: $bh-black;
      margin-bottom: 0;
    }
    table {
      border-spacing: 0 15px;
      td {
        vertical-align: top;
      }
      th {
        text-align: left;
        &:last-of-type {
          text-align: right;
        }
      }
      td:first-of-type {
        width: 64%;
      }
      td:nth-of-type(3) {
        width: 8%;
        font-size: 1.5em;
        font-weight: bold;
        text-align: right;
        i {
          height: 24px;
          display: inline-block;
        }
      }
    }
    &__score {
      width: 200px;
      position: relative;
      flex-grow: 0 !important;
      margin-right: 40px;
      .horizontal-value-bar {
        background: $bh-blue--4;
        &__wrapper {
          padding-top: 8px;
        }
        &__details {
          label {
            display: none;
          }
          p {
            position: absolute;
            right: 0;
            top: 0;
            strong {
              font-size: 1.5em;
            }
          }
        }
      }
    }
    .v-expansion-panel-content {
      table {
      }
    }
  }
}
</style>
